import { render, staticRenderFns } from "./standard-view.vue?vue&type=template&id=fdf230ce&scoped=true&"
import script from "./standard-view.vue?vue&type=script&lang=ts&"
export * from "./standard-view.vue?vue&type=script&lang=ts&"
import style0 from "./standard-view.vue?vue&type=style&index=0&id=fdf230ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf230ce",
  null
  
)

export default component.exports